export function extractMetadataUriHash(uri: string) {
  return uri.split('/').at(-1) || '-'
}
